import { Status } from './Status';

const name = 'Status';
export { name, Status };

export type { StatusProps } from './types';
